import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserComponent } from './user.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: UserComponent,
      children: [
      {path: '', redirectTo: $localize `zamowienia`, pathMatch: 'full'},
      {path: $localize `profil`, loadChildren: () => import('./user-details.module').then(m => m.UserDetailsModule)},
      {path: $localize `haslo`, loadChildren: () => import('./user-password.module').then(m => m.UserPasswordModule)},
      {path: $localize `zamowienia`, loadChildren: () => import('./user-orders.module').then(m => m.UserOrdersModule)},
      {path: $localize `rabaty`, loadChildren: () => import('./user-discounts.module').then(m => m.UserDiscountsModule)},
      {path: $localize `bonusy`, loadChildren: () => import('./user-bonuses.module').then(m => m.UserBonusesModule)},
      {path: $localize `faktury`, loadChildren: () => import('./user-documents.module').then(m => m.UserDocumentsModule)},
      {path: $localize `ewidencja`, loadChildren: () => import('./user-evidences.module').then(m => m.UserEvidencesModule)},
      {path: $localize `zwroty`, loadChildren: () => import('./user-returns.module').then(m => m.UserReturnsModule)},
      {path: $localize `kontakty`, loadChildren: () => import('./user-contacts.module').then(m => m.UserContactsModule)},
      {path: $localize `pliki`, loadChildren: () => import('./user-files.module').then(m => m.UserFilesModule)},
      {path: $localize `pracownicy`, loadChildren: () => import('./user-users.module').then(m => m.UserUsersModule)},
      {path: $localize `gwarancje`, loadChildren: () => import('./user-warranties.module').then(m => m.UserWarrantiesModule)}
      ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class UserRoutingModule { }
